import React, { useState, useEffect } from 'react';
import AlertNotification from '@vfuk/core-alert-notification';
import { OverlayProvider } from '@vfuk/core-overlay-controller';
import Modal from '@vfuk/core-modal';
import SimpleGrid from '@vfuk/core-simple-grid';
import Button from '@vfuk/core-button';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { navigate } from 'gatsby';
import runSeoEventData from '../../../../../helpers/runSeoData';
import { DownvotePopupTypes } from '../Types/DownvotePopupTypes';
import {
  ImageWrapper,
  DownvoteHeaderText,
  DownvoteFeedback,
  ButtonContainer,
  CardButtonContainer,
  ContentContainer,
  CardsContainer,
} from '../styles/DownvotePopup.styles';

const DownvotePopup = ({
  content,
  setStopSubmitLoader,
  patchDocumentApi,
  itemId,
  stopSubmitLoader,
  showOverlay,
  setToggleOverlay,
  voteObject,
  downvoteSubmitError,
}: DownvotePopupTypes) => {
  const [enableSubmitBtn, setEnableSubmitBtn] = useState<string>('');
  const [popupsubmitloader, setPopupSubmitLoader] = useState<boolean>(false);
  const [cleartextbox, setClearTextBox] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<string>('');

  const downVoteOnchange = (text: string) => {
    setSelectedOption(text);
    setEnableSubmitBtn(text);
  };

  const closeDownvotePopup = () => {
    setSelectedOption('');
    setToggleOverlay(!showOverlay);
    setClearTextBox('');
    setEnableSubmitBtn('');
    setStopSubmitLoader(false);
  };

  const downVoteSubmitBtn = async () => {
    const feedbackText: string = cleartextbox
      ? selectedOption
        ? selectedOption + ` ${cleartextbox}`
        : cleartextbox
      : selectedOption;
    setEnableSubmitBtn('');
    setPopupSubmitLoader(true);
    await setTimeout(() => {
      setPopupSubmitLoader(true);
    }, 1);
    await patchDocumentApi(itemId, 'downvote', feedbackText, voteObject);
    runSeoEventData(content.downvotePopup.button.seoEventData.seoEventData);
    setSelectedOption('');
    setPopupSubmitLoader(false);
    setToggleOverlay(!showOverlay);
  };

  const textAreaChangeHandler = element => {
    const maxLength = 300;
    const text = element.target.value.slice(0, maxLength);
    const trimmedText = text.trim().split(/ +/).join(' ');
    setClearTextBox(trimmedText !== '' ? text : '');
    selectedOption
      ? setEnableSubmitBtn(selectedOption)
      : setEnableSubmitBtn(trimmedText !== '' ? text : '');
  };

  useEffect(() => {
    if (stopSubmitLoader) {
      setPopupSubmitLoader(false);
      setEnableSubmitBtn('disabled');
    }
  }, [downVoteSubmitBtn]);

  useEffect(() => {
    setClearTextBox('');
    const downvoteOptions: any = document.getElementsByName('radio');
    for (let i = 0; i < downvoteOptions.length; i++) {
      downvoteOptions[i].checked = false;
    }
    setPopupSubmitLoader(false);
  }, [showOverlay]);

  return (
    <OverlayProvider>
      <Modal
        srName="downvote-modal"
        isOpen={showOverlay}
        size={4}
        animate
        isClosable
        onCloseCb={closeDownvotePopup}
      >
        <div className="overlay2">
          <ContentContainer>
            <ImageWrapper className="sad-image-downvote">
              <img
                src={content.downvotePopup.downvoteIcon.file.url}
                alt="downvoteimage"
              />
            </ImageWrapper>
            <DownvoteHeaderText className="downvote-message">
              {content.downvotePopup.downvoteHeaderText}
            </DownvoteHeaderText>
            <DownvoteFeedback className="please-give-us-your">
              {content.downvotePopup.downvoteDespText}
            </DownvoteFeedback>
            {/* feedback form started currently it's inprogress future it will integrate with DXL APIS */}
            <div className="containerRadio" style={{ marginBottom: 35 }}>
              <div className="radio">
                <input
                  id="radio-1"
                  name="radio"
                  type="radio"
                  onChange={() => {
                    downVoteOnchange(content.downvotePopup.downvoteOption1);
                  }}
                />
                <label htmlFor="radio-1" className="radio-label">
                  {content.downvotePopup.downvoteOption1}
                </label>
              </div>
              <div className="radio">
                <input
                  id="radio-2"
                  name="radio"
                  type="radio"
                  onChange={() => {
                    downVoteOnchange(content.downvotePopup.downvoteOption2);
                  }}
                />
                <label htmlFor="radio-2" className="radio-label">
                  {content.downvotePopup.downvoteOption2}
                </label>
              </div>
              <div className="radioTxtField">
                <div className="text-area-label">
                  <label htmlFor="radio-4" className="radio-label">
                    {content.downvotePopup.downvoteOption4.label}
                  </label>
                  <br />
                </div>
                <textarea
                  name="other_reason"
                  maxLength={300}
                  className="placeholder-downvote"
                  value={cleartextbox}
                  placeholder={content.downvotePopup.downvoteOption4.placeholder}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): void => {
                    textAreaChangeHandler(e);
                  }}
                />
              </div>
            </div>
            {/* feedback form ended */}
            <div style={{ position: 'relative' }}>
              {downvoteSubmitError && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      fontSize: '16px',
                      position: 'absolute',
                      zIndex: 1000,
                      top: -50,
                    }}
                  >
                    <AlertNotification state="error">
                      Request Failed, Please try again
                    </AlertNotification>
                  </div>
                </div>
              )}
              <ButtonContainer>
                <Button
                  text={content.downvotePopup.button.label}
                  appearance={content.downvotePopup.button.rank}
                  onClick={downVoteSubmitBtn}
                  state={!enableSubmitBtn ? 'disabled' : undefined}
                  loading={popupsubmitloader}
                />
              </ButtonContainer>
            </div>
          </ContentContainer>
          {/* Start - need to move this to a seperate component */}
          <CardsContainer>
            <SimpleGrid
              columns={{
                sm: 1,
                md: 1,
                lg: 1,
                xl: 1,
              }}
              className="downvore-heading-grid"
            >
              <div>
                <h2 className="downvote-heading-text">
                  {content?.downvotePopup?.cardHeaderText}
                </h2>
              </div>
            </SimpleGrid>
            <SimpleGrid
              columns={{
                sm: 1,
                md: 3,
                lg: 3,
                xl: 3,
              }}
              className="downvote-grid"
              spacing={4}
            >
              {content?.downvotePopup?.cardContent &&
                content?.downvotePopup?.cardContent?.length > 0 &&
                content?.downvotePopup?.cardContent?.map((card: any) => (
                  <div>
                    <div className="downvote-card-one">
                      <GatsbyImage
                        image={getImage(card.mainImage) as IGatsbyImageData}
                        alt={
                          card.mainImage.description
                            ? card.mainImage.description
                            : card.mainImage.title
                        }
                      />

                      <div className="downvote-card-body">
                        <h5 className="downvote-card-title">
                          {card.cardHeading}
                        </h5>
                        <p className="downvote-card-text">
                          {card.cardSummary.cardSummary}
                        </p>
                        <CardButtonContainer>
                          <Button
                            text={card.button.label}
                            appearance={card.button.rank === "transparent" ? "alt1" : card.button.rank}
                            onClick={() => {
                              navigate(`${card.button.url}`);
                              runSeoEventData(
                                card.button.seoEventData.seoEventData
                              );
                            }}
                          />
                        </CardButtonContainer>
                      </div>
                    </div>
                  </div>
                ))}
            </SimpleGrid>
          </CardsContainer>
          {/* End - need to move this to a seperate component */}
        </div>
      </Modal>
    </OverlayProvider>
  );
};
export default DownvotePopup;
